export default __webpack_public_path__ + "static/media/evenshot.dabca53c.png";